import { Stack, Typography } from '@mui/material';
import { IconSvg } from '@/components/Icon';
import LoadingButton from '@/components/LoadingButton';
type Props = {
  sendOtp: () => void;
  loading: boolean;
};
const RequestSejamSendOtp = (props: Props) => {
  return <Stack alignItems='center' sx={{
    px: {
      xs: 'var(--spacing_m)',
      md: 'var(--spacing_xl)'
    }
  }} data-sentry-element="Stack" data-sentry-component="RequestSejamSendOtp" data-sentry-source-file="RequestSejamSendOtp.tsx">
      <Stack alignItems='center' sx={{
      width: '100%',
      fontSize: {
        xs: 56,
        md: 72
      },
      py: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_l)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="RequestSejamSendOtp.tsx">
        <IconSvg component='Sejam' data-sentry-element="IconSvg" data-sentry-source-file="RequestSejamSendOtp.tsx" />
      </Stack>
      <Typography component='p' sx={{
      typography: {
        xs: 'bodyRegular__Wallfund',
        md: 'bodyLargeRegular__Wallfund'
      },
      py: 'var(--spacing_s)'
    }} data-sentry-element="Typography" data-sentry-source-file="RequestSejamSendOtp.tsx">
        جهت احراز هویت توسط{' '}
        <Typography component='strong' sx={{
        typography: {
          xs: 'bodyStrong__Wallfund',
          md: 'bodyLargeStrong__Wallfund'
        }
      }} data-sentry-element="Typography" data-sentry-source-file="RequestSejamSendOtp.tsx">
          کارگزاری بانک صادرات
        </Typography>
        ، کد تاییدی از سوی{' '}
        <Typography component='strong' sx={{
        typography: {
          xs: 'bodyStrong__Wallfund',
          md: 'bodyLargeStrong__Wallfund'
        }
      }} data-sentry-element="Typography" data-sentry-source-file="RequestSejamSendOtp.tsx">
          سجام
        </Typography>{' '}
        به شماره موبایلی که در حساب سجام خود ثبت کرده‌اید، ارسال خواهد شد.{' '}
      </Typography>
      <Stack sx={{
      width: '100%',
      pt: 'var(--spacing_m)',
      pb: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_xl)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="RequestSejamSendOtp.tsx">
        <LoadingButton onClick={props.sendOtp} loading={props.loading} fullWidth color='primary' variant='contained' size='large' data-sentry-element="LoadingButton" data-sentry-source-file="RequestSejamSendOtp.tsx">
          درخواست ارسال کد تایید
        </LoadingButton>
      </Stack>
    </Stack>;
};
export default RequestSejamSendOtp;